module.exports = __webpack_public_path__ + "img/logo-footer.a68fe34b.svg";